export default {"src":"/_next/static/media/evaluation.e2a105ed.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};